module.exports = __webpack_public_path__ + "static/img/logo-qyzy.0aa22c99.png";